import React from "react";
import { LandPlot, Layout, PenTool, FileText, Building } from "lucide-react";
import SectionHeader from "@/components/SectionHeader";
import EnquiryForm from "@/components/EnquiryForm";

const SERVICES = [
  { icon: LandPlot, title: "Plot Planning", desc: "Site-specific layout concepts based on field survey and client brief." },
  { icon: Layout, title: "Site Layout Planning", desc: "Internal road, setback and plot arrangement concepts." },
  { icon: Building, title: "Residential Site Planning", desc: "Preliminary site layout and plot arrangement for residential projects." },
  { icon: PenTool, title: "Floor Plan Drafting", desc: "Indicative floor plans for discussion and concept finalisation." },
  { icon: FileText, title: "Preliminary Building Layout", desc: "Early-stage building footprint and massing concepts." },
  { icon: LandPlot, title: "Land Subdivision Concept", desc: "Subdivision options for larger plots, informed by field data." },
];

export default function Planning() {
  return (
    <>
      <section className="bg-[#101827] text-white">
        <div className="ae-container pt-28 pb-16">
          <div className="ae-eyebrow mb-3">Property Planning</div>
          <h1 className="font-display text-4xl sm:text-5xl lg:text-6xl font-semibold max-w-3xl">Early-stage planning that saves time later.</h1>
          <p className="text-white/80 mt-5 max-w-3xl leading-relaxed">
            From plot planning and subdivision concepts to preliminary building layouts and site
            plans — grounded in field data and client intent.
          </p>
        </div>
      </section>

      <section className="ae-section">
        <div className="ae-container grid lg:grid-cols-12 gap-10">
          <div className="lg:col-span-8">
            <div className="grid md:grid-cols-2 gap-5">
              {SERVICES.map((s, i) => (
                <div key={i} className="ae-card p-6">
                  <div className="w-11 h-11 rounded-lg bg-[#101827] text-[#C5A46D] flex items-center justify-center mb-4"><s.icon className="w-5 h-5" /></div>
                  <h3 className="font-semibold text-[#101827] text-lg mb-1.5">{s.title}</h3>
                  <p className="text-[#64748B] text-sm leading-relaxed">{s.desc}</p>
                </div>
              ))}
            </div>
            <div className="ae-card p-6 mt-8 border-l-4 border-l-[#C5A46D]">
              <h4 className="font-semibold text-[#101827] mb-1">Scope note</h4>
              <p className="text-[#475569] text-sm leading-relaxed">
                Preliminary planning and drafting are advisory outputs. Statutory architectural approvals,
                engineering sign-offs and licensed professional work are handled by appropriately qualified
                professionals outside the scope of this service.
              </p>
            </div>
          </div>
          <aside className="lg:col-span-4">
            <div className="ae-card p-6 sticky top-28">
              <EnquiryForm defaultService="planning_request" sourcePage="planning" title="Start a planning discussion" />
            </div>
          </aside>
        </div>
      </section>
    </>
  );
}
